import { render, staticRenderFns } from "./ClientProjectModal.vue?vue&type=template&id=23df3a29&"
import script from "./ClientProjectModal.vue?vue&type=script&lang=js&"
export * from "./ClientProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports